module.exports = __webpack_public_path__ + "img/bg.9aa63092.png";